export const lang = {
	str_title: `中文`,
	str_index: `首頁`,
	str_neiye: '大廳',
	str_activity: `活動`,
	str_service: `客服`,
	str_my: `我的`,
	str_more: `更多`,
	str_save: `儲存`,
	str_sure: `確定`,
	str_update: `立即升級`,
	str_serviceName: `聯系客服`,
	str_confirm: `確認`,
	str_tabs_charge: `充值`,
	str_tabs_Withdrawal: `提款`,
	str_tabs_integral: `點數`,
	str_tabs_activity: `活動`,
	str_loginBefore: `會員登入`,
	str_loginBeforeBalance: `會員註冊`,
	str_1_8: `1分時時彩`,
	str_1_9: `5分時時彩`,
	str_1_10: `5分賽車`,
	str_1_11: `1分賽車`,
	str_1_12: `1秒骰寶`,
	str_1_13: `1分骰寶`,
	str_1_14: `1秒六合彩`,
	str_1_15: `5分六合彩`,
	str_1_27: `色碟1秒`,
	str_1_28: `色碟1分`,
	str_1_29: `魚蝦蟹1秒`,
	str_1_30: `魚蝦蟹1分`,
	str_1_31: `猜拳1秒`,
	str_1_32: '猜拳1分',
	str_1_203: `南部1分彩`,
	str_1_204: `中部1分彩`,
	str_1_205: `北部1分彩`,
	str_1_100: `福神報喜`,
	str_1_101: `發發發2`,
	str_1_102: `決戰三國`,
	str_1_103: `德古拉夫人`,
	str_1_104: `埃及寶藏`,
	str_1_1000: '飛龍捕魚',
	str_1_1001: '星空捕魚',
	str_1_1002: '經典捕魚',
	str_1_1003: '復古捕魚',
	str_1_1004: '街機捕魚',




	str_100_30300101: `神龍寶藏`,
	str_100_30300501: `悟空打魚`,
	str_100_30300201: `搖錢樹`,
	str_100_30300301: `金蟾捕魚`,
	str_100_30300401: `李逵劈魚`,
	str_100_30300601: `大聖鬧海`,
	str_100_30300701: `三色鱷魚`,
	str_1_105: `南部-胡志明`,
	str_1_106: `南部-銅塔`,
	str_1_107: `南部-金甌`,
	str_1_108: `南部-檳椥`,
	str_1_109: `南部-頭頓`,
	str_1_110: `南部-薄遼`,
	str_1_111: `南部-同奈`,
	str_1_112: `南部-芹苴`,
	str_1_113: `南部-朔莊`,
	str_1_114: `南部-西寧`,
	str_1_115: `南部-安江`,
	str_1_116: `南部-平順`,
	str_1_117: `南部-永隆`,
	str_1_118: `南部-平陽`,
	str_1_119: `南部-茶榮`,
	str_1_120: `南部-隆安`,
	str_1_121: `南部-平福`,
	str_1_122: `南部-豪江`,
	str_1_123: `南部-田江`,
	str_1_124: `南部-堅江`,
	str_1_125: `南部-大叻`,
	str_1_126: `中部-順華`,
	str_1_127: `中部-富安`,
	str_1_128: `中部-得樂`,
	str_1_129: `中部-廣南`,
	str_1_130: `中部-峴港`,
	str_1_131: `中部-慶和`,
	str_1_132: `中部-平定`,
	str_1_133: `中部-廣治`,
	str_1_134: `中部-廣平`,
	str_1_135: `中部-嘉萊`,
	str_1_136: `中部-寧順`,
	str_1_137: `中部-廣義`,
	str_1_138: `中部-德濃`,
	str_1_139: `中部-昆嵩`,
	str_1_140: `南部-胡志明 VIP`,
	str_1_200: `北部`,
	str_1_201: `北部-樂透 18h25`,
	str_1_202: `北部-河內 VIP`,
	str_1_206: `樂透一分彩`,


	str_1_300: `東海龍王`,
	str_1_303: `撒哈拉之夜`,
	str_1_304: `澤達的財富`,



	str_2_0: `WM大廳`,
	str_8_0: `BBIN大廳`,
	str_10_0: `DG大廳`,
	str_9_0: `SEXY大廳`,
	str_2_101: `百家樂`,
	str_2_102: `龍虎`,
	str_2_103: `輪盤`,
	str_2_104: `骰寶`,
	str_2_105: `牛牛`,
	str_2_106: `三公`,
	str_2_107: `番攤`,
	str_2_108: `色碟`,
	str_2_110: `魚蝦蟹`,
	str_2_111: `炸金花`,
	str_2_112: `溫州牌九`,
	str_2_113: `二八槓`,
	str_2_114: `安達巴哈`,
	str_5_Unknown: `Unknown`,
	str_5_Soccer: `足球`,
	str_5_Basketball: `籃球`,
	str_5_Football: `美式足球`,
	str_5_IceHockey: `冰球`,
	str_5_Badminton: `羽毛球`,
	str_5_Pool: `檯球/斯諾克`,
	str_5_Motor_Sport: `賽車`,
	str_5_Tennis: `網球`,
	str_5_5_Baseball: `棒球`,
	str_5_Volleyball: `排球`,
	str_5_Others: `其他`,
	str_5_Golf: `高爾夫球`,
	str_5_Boxing: `拳擊`,
	str_5_Cricket: `板球`,
	str_5_Table_Tennis: `乒乓球`,
	str_5_Rugby: `橄欖球`,
	str_5_Handball: `手球`,
	str_5_Cycling: `腳踏車`,
	str_5_Athletics: `競技`,
	str_5_Beach_Soccer: `沙灘足球`,
	str_5_Futsal: `室內足球`,
	str_5_Entertainment: `獨特`,
	str_5_Financial: `金融`,
	str_5_Darts: `飛鏢`,
	str_5_Olympic: `奧林匹克`,
	str_5_Lacrosse: `長曲棍球`,
	str_5_Water_Polo: `水球`,
	str_5_Winter_Sports: `冬季運動`,
	str_5_Squash: `壁球`,
	str_5_Field_Hockey: `曲棍球`,
	str_5_Mixed_Martial_Arts: `綜合格鬥`,
	str_5_E_Sports: `電子競技`,
	str_5_Gaelic_Football: `蓋爾足球`,
	str_5_Hurling: `板棍球`,
	str_5_Muay_Thai: `泰拳`,
	str_5_Aussie_Rules_Football: `澳式足球`,
	str_5_Bandy: `班迪球`,
	str_5_Winter_Olympics: `冬奧會`,
	str_6_1: `鑽石水果王`,
	str_6_8: `甜蜜蜜`,
	str_6_60: `叢林舞會`,
	str_6_2: `棋聖`,
	str_6_10: `五福臨門`,
	str_6_35: `瘋狂哪吒`,
	str_6_39: `飛天`,
	str_6_57: `神獸爭霸`,
	str_6_54: `火草泥馬`,
	str_6_66: `火爆777`,
	str_6_69: `發財神`,
	str_6_70: `萬飽龍`,
	str_6_72: `好運年年`,
	str_6_74: `聚寶盆`,
	str_6_76: `旺旺旺`,
	str_6_77: `火鳳凰`,
	str_6_78: `阿波羅`,
	str_6_80: `傳奇海神`,
	str_6_61: `天天吃豆`,
	str_6_55: `魔龍傳奇`,
	str_6_68: `悟空偷桃`,
	str_6_204: `百寶箱`,
	str_6_83: `火之女王`,
	str_6_1074: `聚寶盆JP`,
	str_6_1010: `五福臨門JP`,
	str_6_1067: `賺金蛋JP`,
	str_6_92: `2018世界盃`,
	str_6_86: `牛逼快跑`,
	str_6_95: `世界盃球鞋`,
	str_6_96: `足球寶貝`,
	str_6_98: `世界盃全明星`,
	str_6_105: `單手跳高高`,
	str_6_104: `海濱消消樂`,
	str_6_122: `印加祖瑪`,
	str_6_131: `直式發財神`,
	str_6_113: `飛天財神`,
	str_6_146: `九連寶燈`,
	str_6_147: `花開富貴`,
	str_6_148: `有如神柱`,
	str_6_157: `五形拳`,
	str_6_150: `壽星大發`,
	str_6_182: `雷神2`,
	str_6_197: `盤龍秘寶`,
	str_6_199: `歡樂潑水節`,
	str_6_CH03: `博丁`,
	str_6_208: `金錢樹`,
	str_6_207: `泰式骰寶`,
	str_6_209: `小愛神`,
	str_6_5: `金大款`,
	str_6_12: `金玉滿堂`,
	str_6_16: `五行`,
	str_6_36: `夜店大亨`,
	str_6_58: `金雞報囍2`,
	str_6_64: `宙斯`,
	str_6_205: `蹦迪`,
	str_6_81: `金銀島`,
	str_6_AS08: `黃金瑪雅`,
	str_6_AS09: `好萊塢寵物`,
	str_6_AS10: `幸運3`,
	str_6_AS17: `塞特的寶藏`,
	str_6_AS18: `瘋狂軟糖`,
	str_6_AS19: `聖誕故事`,
	str_6_AS20: `死亡女王`,
	str_6_99: `跳更高`,
	str_6_103: `寶石配對`,
	str_6_102: `水果派對`,
	str_6_118: `老司機`,
	str_6_130: `偷金妹子`,
	str_6_135: `直式金雞報喜`,
	str_6_136: `奔跑吧猛獸`,
	str_6_137: `直式蹦迪`,
	str_6_138: `跳過來`,
	str_6_139: `直式火燒連環船`,
	str_6_140: `火燒連環船2`,
	str_6_141: `聖誕來啦`,
	str_6_142: `火神`,
	str_6_143: `發財福娃`,
	str_6_144: `鑽更多`,
	str_6_AT01: `一炮捕魚`,
	str_6_112: `盜法老墓`,
	str_6_152: `雙飛`,
	str_6_153: `六顆糖`,
	str_6_154: `宙斯他爹`,
	str_6_160: `發財神2`,
	str_6_163: `哪吒再臨`,
	str_6_161: `大力神`,
	str_6_173: `666`,
	str_6_183: `野狼Disco`,
	str_6_CA01: `亞星CQ9真人`,
	str_6_4: `森林泰後`,
	str_6_9: `鍾馗運財`,
	str_6_13: `櫻花妹子`,
	str_6_17: `祥獅獻瑞`,
	str_6_201: `拳霸`,
	str_6_203: `嗨起來`,
	str_6_79: `變色龍`,
	str_6_89: `雷神`,
	str_6_AS01: `運氣靴`,
	str_6_AS02: `瘋狂馬戲團`,
	str_6_AS03: `馴龍高手`,
	str_6_121: `直式跳起來2`,
	str_6_124: `鎖象無敵`,
	str_6_125: `直式宙斯`,
	str_6_127: `直式武聖`,
	str_6_128: `轉大錢`,
	str_6_129: `直式金雞報喜2`,
	str_6_133: `直式鴻福齊天`,
	str_6_AS33: `豬的運氣`,
	str_6_3: `血之吻`,
	str_6_7: `跳起來`,
	str_6_15: `金雞報喜`,
	str_6_19: `風火輪`,
	str_6_20: `發發發`,
	str_6_21: `野狼傳說`,
	str_6_22: `庶務西遊二課`,
	str_6_23: `金元寶`,
	str_6_24: `跳起來2`,
	str_6_26: `777`,
	str_6_27: `魔法世界`,
	str_6_29: `水世界`,
	str_6_31: `武聖`,
	str_6_32: `通天神探狄仁傑`,
	str_6_33: `火燒連環船`,
	str_6_34: `地鼠戰役`,
	str_6_38: `舞力全開`,
	str_6_42: `福爾摩斯`,
	str_6_44: `豪華水果王`,
	str_6_46: `狼月`,
	str_6_47: `法老寶藏`,
	str_6_49: `寂寞星球`,
	str_6_50: `鴻福齊天`,
	str_6_51: `嗨爆大馬戲`,
	str_6_52: `跳高高`,
	str_6_202: `舞媚娘`,
	str_6_67: `賺金蛋`,
	str_6_AB3: `皇金漁場`,
	str_6_59: `夏日猩情`,
	str_6_180: `金雞報囍3`,
	str_6_179: `跳高高2`,
	str_6_GO169: `招財龍小鋼珠`,
	str_6_185: `龍珠`,
	str_6_186: `火之女王2`,
	str_6_195: `富貴象`,
	str_6_196: `十倍金喜`,
	str_6_200: `跑跑愛麗絲`,
	str_6_AS04: `財富幽靈`,
	str_6_108: `直式跳更高`,
	str_6_109: `單手跳起來`,
	str_6_111: `飛起來`,
	str_6_115: `冰雪女王`,
	str_6_116: `夢遊仙境`,
	str_6_117: `東方神起`,
	str_6_221: `狄仁傑四大天王`,
	str_6_123: `直式五福臨門`,
	str_6_132: `再喵一個`,
	str_6_AT05: `歡樂捕魚`,
	str_6_184: `六顆扭蛋`,
	str_6_BT02: `搶莊骰子牛牛`,
	str_6_187: `詠春`,
	str_6_188: `板球狂熱`,
	str_6_194: `飛龍在天`,
	str_6_BT03: `搶莊眯牌牛牛`,
	str_6_AT101: `賓士寶馬`,
	str_6_5007: `大發財`,
	str_6_5008: `大紅中`,
	str_6_5009: `大鬧天宮`,
	str_6_206: `甜蜜暴擊`,
	str_6_210: `嗚嘎嚇嘎`,
	str_6_212: `火爆西遊`,
	str_6_213: `迷你輪盤`,
	str_6_214: `忍者浣熊`,
	str_6_GO01: `龍珠推幣機`,
	str_6_GB1: `３２１發射`,
	str_6_GB198: `彩猴賓果`,
	str_6_215: `辣爆了`,
	str_6_211: `海王`,
	str_6_GB2: `怪獸獵人`,
	str_6_216: `色碟`,
	str_6_217: `麻將水果盤`,
	str_6_177: `小夥與神燈`,
	str_6_GB6: `富貴小象神`,
	str_6_218: `達拉崩吧`,
	str_6_219: `金猩特調`,
	str_6_220: `這市集絕了`,
	str_6_222: `水上泰神祈`,
	str_6_GB3: `轉轉金幣`,
	str_7_0: `大廳`,
	str_7_620: `德州撲克`,
	str_7_720: `二八槓`,
	str_7_830: `搶莊牛牛`,
	str_7_220: `炸金花`,
	str_7_860: `三公`,
	str_7_900: `押莊龍虎`,
	str_7_600: `21 點`,
	str_7_870: `通比牛牛`,
	str_7_230: `極速炸金花`,
	str_7_730: `搶莊牌九`,
	str_7_630: `十三水`,
	str_7_610: `鬥地主`,
	str_7_910: `百家樂`,
	str_7_920: `森林舞會`,
	str_7_930: `百人牛牛`,
	str_7_1950: `萬人炸金花`,
	str_7_650: `血流成河`,
	str_7_890: `看牌搶莊牛牛`,
	str_7_740: `二人麻將`,
	str_7_1350: `幸運轉盤（ 不能單獨接入）`,
	str_7_1940: `金鯊銀鯊`,
	str_7_1960: `賓士寶馬`,
	str_7_1980: `百人骰寶`,
	str_7_1810: `單挑牛牛`,
	str_7_1990: `炸金牛`,
	str_7_1850: `押寶搶莊牛牛`,
	str_7_510: `紅包捕魚`,
	str_7_1355: `搏一搏（ 不能單獨接入）`,
	str_7_1970: `五星宏輝`,
	str_7_1860: `賭場撲克`,
	str_7_1370: `港式梭哈`,
	str_7_1690: `血戰骰寶`,
	str_7_1890: `水果機`,
	str_7_1610: `幸運奪寶（ 不能單獨接入）`,
	str_7_1930: `魚蝦蟹`,
	str_7_8130: `跑得快`,
	str_7_950: `紅黑大戰`,
	str_7_840: `瘋狂搶莊牛牛`,
	str_7_1710: `馬戰競猜（ 不能單獨接入）`,
	str_7_520: `李逵捕魚`,
	str_9_MX_LIVE_001: `經典百家`,
	str_9_MX_LIVE_002: `百家樂`,
	str_9_MX_LIVE_0039: `9_MX_LIVE_003 保險百家`,
	str_9_MX_LIVE_006: `龍虎`,
	str_9_MX_LIVE_007: `骰寶`,
	str_9_MX_LIVE_009: `輪盤`,
	str_9_MX_LIVE_010: `紅藍骰`,
	str_10_1: `百家樂`,
	str_10_3: `龍虎`,
	str_10_4: `輪盤`,
	str_10_5: `骰寶`,
	str_10_7: `鬥牛`,
	str_10_6: `番攤`,
	str_10_8: `競咪百家樂`,
	str_10_11: `炸金花`,
	str_10_12: `極速骰寶`,
	str_10_14: `色碟`,
	str_10_15: `魚蝦蟹`,
	str_10_51: `實況幸運5`,
	str_10_52: `實況幸運10`,
	str_12_0: `大廳`,
	str_12_620: `德州撲克`,
	str_12_720: `二八槓`,
	str_12_830: `搶莊牛牛`,
	str_12_220: `炸金花`,
	str_12_860: `三公`,
	str_12_900: `龍虎鬥`,
	str_12_600: `21 點`,
	str_12_870: `通比牛牛`,
	str_12_230: `極速炸金花`,
	str_12_730: `搶莊牌九`,
	str_12_630: `十三水`,
	str_12_610: `鬥地主`,
	str_12_890: `看三張搶莊牛牛`,
	str_12_910: `百家樂`,
	str_12_950: `紅黑大戰`,
	str_12_740: `二人麻將`,
	str_12_930: `百人牛牛`,
	str_12_510: `捕魚大作戰`,
	str_12_8120: `血戰到底`,
	str_12_920: `森林舞會`,
	str_12_8150: `看四張搶莊牛牛`,
	str_12_8180: `寶石消消樂`,
	str_12_8160: `癩子牛牛`,
	str_12_8210: `搏一搏`,
	str_12_8130: `跑得快`,
	str_12_8200: `搶莊選三張`,
	str_12_8190: `萬人推筒子`,
	str_12_8220: `搶紅包`,
	str_12_8230: `百萬紅包`,
	str_12_940: `金鯊銀鯊`,
	str_12_8260: `頭號玩家`,
	str_12_8270: `歡樂炸金花`,
	str_12_8280: `好友包房8281`,
	str_12_8281: `好友包房搶莊牛牛`,
	str_12_8250: `豪車漂移`,
	str_12_8110: `血流成河`,
	str_12_8310: `財神到`,
	str_12_8140: `水果機`,
	str_12_8340: `十點半`,
	str_12_8320: `黑紅梅方8330`,
	str_12_8330: `極速賽車`,
	str_12_8410: `賭場撲克`,
	str_12_8450: `骰寶搶莊牛牛`,
	str_12_8460: `骰寶搶莊三公`,
	str_12_8470: `骰寶通比三公`,
	str_12_8480: `骰寶紅黑單雙`,
	str_12_8490: `骰寶血戰到底`,
	str_12_8500: `大話骰 067`,
	str_12_8510: `大話骰齋劈`,
	str_12_8360: `古怪猴子`,
	str_12_8440: `港式梭哈`,
	str_12_8420: `上莊百人牛牛`,
	str_12_8282: `好友房德州撲克`,
	str_12_8550: `炸金牛`,
	str_12_8600: `推倒胡`,
	str_12_8640: `多人骰寶`,
	str_12_8231: `幸運紅包`,
	str_12_8680: `二人牛牛`,
	str_12_8620: `骰子牛牛`,
	str_12_8630: `乾瞪眼`,
	str_12_8650: `搶莊牛牛比賽版`,
	str_12_8690: `百人炸金花`,
	str_12_8660: `歐式輪盤`,
	str_12_8750: `經典梭哈`,
	str_12_8740: `鬥金花`,
	str_12_8820: `快樂捕魚趣`,
	str_12_8730: `魚躍龍門`,
	str_12_8810: `賭場戰爭`,
	str_12_8700: `百人德撲`,
	str_12_8720: `百人射龍門`,
	str_8_3001: `百家樂`,
	str_8_3003: `龍虎鬥`,
	str_8_3005: `三公`,
	str_8_3006: `溫州牌九`,
	str_8_3007: `輪盤`,
	str_8_3008: `骰寶`,
	str_8_3011: `色碟`,
	str_8_3012: `牛牛`,
	str_8_3015: `番攤`,
	str_8_3016: `魚蝦蟹`,
	str_8_3017: `保險百家樂`,
	str_8_3018: `炸金花`,
	str_8_3021: `HiLo`,
	str_8_3025: `區塊鏈百家樂`,
	str_8_3026: `區塊鏈龍虎鬥`,
	str_8_3027: `區塊鏈保險百家樂`,
	str_8_3028: `區塊鏈輪盤`,
	str_8_3029: `區塊鏈炸金花`,
	str_8_3030: `區塊鏈三公`,
	str_8_3031: `區塊鏈牛牛`,
	str_8_3032: `區塊鏈色碟`,
	str_8_3033: `區塊鏈骰寶`,
	str_8_3034: `區塊鏈魚蝦蟹`,
	str_8_3036: `區塊鏈HiLo`,
	str_8_3037: `區塊鏈番攤`,
	str_8_3038: `區塊鏈溫州牌九`,
	str_8_3039: `區塊鏈越南魚蝦蟹`,
	str_8_3043: `區塊鏈21點百家樂`,
	str_8_3045: `區塊鏈泰國魚蝦蟹`,
	str_8_3047: `21點百家樂`,
	str_8_109001: `足球`,
	str_8_109002: `籃球`,
	str_8_109003: `美式足球`,
	str_8_109004: `網球`,
	str_8_109005: `棒球`,
	str_8_109006: `冰上曲棍球`,
	str_8_109007: `排球`,
	str_8_109008: `電子競技`,
	str_8_109009: `羽毛球`,
	str_8_109010: `司諾克`,
	str_8_109012: `拳擊/MMA 綜合格鬥`,
	str_8_109013: `乒乓球`,
	str_8_109014: `橄欖球`,
	str_8_109017: `手球`,
	str_8_109018: `草地曲棍球`,
	str_8_109019: `賽車`,
	str_8_109020: `高爾夫`,
	str_8_109023: `飛鏢`,
	str_8_109025: `水球`,
	str_8_109029: `板球`,
	str_8_109040: `籃網球`,
	str_8_109051: `沙灘排球`,
	str_8_109065: `沙灘足球`,
	str_8_109082: `CS GO`,
	str_8_109083: `刀塔2`,
	str_8_109084: `英雄聯盟`,
	str_8_109132: `電競足球`,
	str_8_109133: `電競籃球`,
	str_8_109147: `王者榮耀`,
	str_8_109159: `電競網球`,
	str_8_109160: `電競冰球`,
	str_8_109161: `電競排球`,
	str_8_109998: `混合過關`,
	str_8_5005: `惑星戰記`,
	str_8_5006: `Staronic`,
	str_8_5008: `猴子爬樹`,
	str_8_5009: `金剛爬樓`,
	str_8_5010: `外星戰記`,
	str_8_5012: `外星爭霸`,
	str_8_5013: `傳統`,
	str_8_5014: `叢林`,
	str_8_5015: `FIFA2010`,
	str_8_5019: `水果樂園`,
	str_8_5027: `功夫龍`,
	str_8_5030: `幸運財神`,
	str_8_5039: `魚蝦蟹`,
	str_8_5043: `鑽石水果盤`,
	str_8_5044: `明星97II`,
	str_8_5045: `森林舞會`,
	str_8_5046: `鬥魂`,
	str_8_5054: `爆骰`,
	str_8_5057: `明星97`,
	str_8_5058: `瘋狂水果盤`,
	str_8_5061: `超級7`,
	str_8_5062: `龍在囧途`,
	str_8_5063: `水果拉霸`,
	str_8_5064: `撲克拉霸`,
	str_8_5065: `筒子拉霸`,
	str_8_5066: `足球拉霸`,
	str_8_5067: `大話西遊`,
	str_8_5068: `酷搜馬戲團`,
	str_8_5069: `水果擂臺`,
	str_8_5076: `數字大轉輪`,
	str_8_5077: `水果大轉輪`,
	str_8_5079: `3D數字大轉輪`,
	str_8_5080: `樂透轉輪`,
	str_8_5083: `鑽石列車`,
	str_8_5084: `聖獸傳說`,
	str_8_5088: `鬥大`,
	str_8_5089: `紅狗`,
	str_8_5090: `金雞報喜`,
	str_8_5093: `金瓶梅`,
	str_8_5094: `金瓶梅2`,
	str_8_5095: `鬥雞`,
	str_8_5096: `五行`,
	str_8_5097: `海底世界`,
	str_8_5098: `五福臨門`,
	str_8_5099: `金狗旺歲`,
	str_8_5100: `七夕`,
	str_8_5105: `歐式輪盤`,
	str_8_5106: `三國`,
	str_8_5107: `美式輪盤`,
	str_8_5108: `彩金輪盤`,
	str_8_5109: `法式輪盤`,
	str_8_5110: `夜上海`,
	str_8_5119: `神秘島`,
	str_8_5120: `女媧補天`,
	str_8_5121: `奧林帕斯`,
	str_8_5122: `球球大作戰`,
	str_8_5123: `經典21點`,
	str_8_5124: `西班牙21點`,
	str_8_5125: `維加斯21點`,
	str_8_5126: `獎金21點`,
	str_8_5127: `絕地求生5128`,
	str_8_5128: `多福多財`,
	str_8_5138: `夾豬珠`,
	str_8_5139: `熊貓樂園`,
	str_8_5140: `啤酒嘉年華`,
	str_8_5141: `鬥牛贏家`,
	str_8_5142: `魔光幻音`,
	str_8_5143: `糖果派對3`,
	str_8_5144: `情人夜`,
	str_8_5145: `步步高昇`,
	str_8_5146: `糖果派`,
	str_8_5150: `寶石傳奇`,
	str_8_5151: `Jenga`,
	str_8_5152: `埃及傳奇`,
	str_8_5153: `九尾狐`,
	str_8_5154: `初音大進擊`,
	str_8_5155: `東海龍宮`,
	str_8_5156: `祖瑪帝國`,
	str_8_5157: `三元四喜`,
	str_8_5159: `瘋狂麥斯`,
	str_8_5160: `雷神索爾`,
	str_8_5162: `開心蛋`,
	str_8_5163: `月狼`,
	str_8_5164: `好事成雙`,
	str_8_5165: `戰神`,
	str_8_5166: `葫蘆娃`,
	str_8_5167: `馬到成功`,
	str_8_5168: `金雞報囍2020`,
	str_8_5169: `中國好聲音`,
	str_8_5170: `海底傳奇`,
	str_8_5171: `糖果派對_極速版`,
	str_8_5172: `偏財神`,
	str_8_5173: `招財進寶`,
	str_8_5174: `電音之王`,
	str_8_5175: `滿天星`,
	str_8_5176: `野蠻戰國`,
	str_8_5177: `蓮花`,
	str_8_5178: `蒸汽王國`,
	str_8_5181: `黎利`,
	str_8_5182: `抖音DJ`,
	str_8_5183: `扭轉錢坤`,
	str_8_5184: `魚躍龍門`,
	str_8_5185: `大豐收`,
	str_8_5186: `七福報喜`,
	str_8_5187: `忍者大師`,
	str_8_5188: `新年快樂`,
	str_8_5189: `牛運當頭`,
	str_8_5191: `豬寶滿滿`,
	str_8_5192: `急凍世界`,
	str_8_5193: `糖果吧`,
	str_8_5194: `黃金財神`,
	str_8_5195: `蜂贏百搭`,
	str_8_5197: `怪物派對`,
	str_8_5198: `下龍灣神話`,
	str_8_5199: `街頭美食`,
	str_8_5200: `魚蝦蟹開了`,
	str_8_5204: `2014 FIFA`,
	str_8_5205: `轟炸樂園`,
	str_8_5206: `金龜神弩`,
	str_8_5207: `武松打虎`,
	str_8_5208: `賓果消消樂`,
	str_8_5209: `草原拍拍`,
	str_8_5210: `糖果繽紛樂`,
	str_8_5211: `多福財神`,
	str_8_5212: `哪吒`,
	str_8_5214: `水果忍者`,
	str_8_5215: `今晚有戲`,
	str_8_5216: `人魚秘寶`,
	str_8_5217: `水果幸運星`,
	str_8_5218: `叢林歷險`,
	str_8_5402: `夜市人生`,
	str_8_5404: `沙灘排球`,
	str_8_5407: `大紅帽與小野狼`,
	str_8_5601: `秘境冒險`,
	str_8_5803: `阿茲特克寶藏`,
	str_8_5805: `凱薩帝國5810`,
	str_8_5810: `航海時代`,
	str_8_5823: `發大財`,
	str_8_5824: `惡龍傳說`,
	str_8_5828: `霸王龍`,
	str_8_5835: `喜福牛年`,
	str_8_5837: `喜福猴年`,
	str_8_5839: `經典高球5901`,
	str_8_5901: `連環奪寶`,
	str_8_5902: `糖果派對`,
	str_8_5903: `秦皇秘寶5904`,
	str_8_5904: `蒸氣炸彈5908`,
	str_8_5908: `糖果派對2`,
	str_8_5909: `開心消消樂`,
	str_8_5910: `魔法元素`,
	str_8_5912: `連環奪寶2`,
	str_8_5888: `JACKPOT`,
	str_8_30599: `捕魚達人`,
	str_8_30598: `捕魚達人2`,
	str_8_30593: `金童捕魚`,
	str_8_38001: `捕魚大師`,
	str_8_38002: `富貴漁場`,
	str_3_kxyznmbpret1y: `魔法森林`,
	str_3_qd1fcneqbhgy4: `無盡`,
	str_3_kdn8ckjqfhsn4: `法老之墓`,
	str_3_d4fyes4amfxf6: `鳳凰`,
	str_3_a7q65cfts455e: `拳擊 2`,
	str_3_cuarr8e1ncebn: `熱帶水果`,
	str_3_96k1k6d3x39za: `森林探險記`,
	str_3_x5ikj69a989x6: `黃金獵者`,
	str_3_c85wq8o9doqtr: `巫師`,
	str_3_hb4cpgc6u6qj4: `西方神話`,
	str_3_wr5axzs95uq7r: `森林寶藏`,
	str_3_cd4rcge6dhqb4: `亡靈節`,
	str_3_exesnxb7ge3uy: `鬼屋`,
	str_3_pd6rhresnhkbk: `少林`,
	str_3_ezjsgctugyauc: `大財神 賓果`,
	str_3_fn6yhwksk7kfk: `辣椒獵人 賓果`,
	str_3_nqyun5dpcjtsy: `網路競賽`,
	str_3_uafejs6a58xp6: `賞金獵人 X`,
	str_3_jzpssktmfyw1h: `十二星座`,
	str_3_7b6c7rcs16kjk: `海洋浪花`,
	str_3_uwf5zss55dc7h: `葉賢`,
	str_3_3fx69pizs144w: `幸運條紋`,
	str_3_6o5emdcnoqyen: `阿茲臺克神廟`,
	str_3_5cx47jffukp3o: `八寶錢袋`,
	str_3_gqotnunpejbwy: `財富佳節`,
	str_3_b1cnw7mkppwg1: `玩命之徒`,
	str_3_6c5apdrpokbay: `財神興盛`,
	str_3_ipz77igi3mfho: `甜蜜冬季`,
	str_3_b5ggg45epfzg6: `超級星球`,
	str_3_93ine65axf986: `拳擊`,
	str_3_4eekxm7cistkg: `龍之領域`,
	str_3_y5n8sh5oqf58q: `虎穴`,
	str_3_r8oiyz19mtqir: `幸運小丑`,
	str_3_ha1jzrho1gmjq: `瑪雅寶石`,
	str_3_3erm9p7wssiks: `命運之火`,
	str_3_ofy9b9z99u69r: `火龍帝國`,
	str_3_swt38osdadyhc: `海盜傳奇`,
	str_3_gkubyu4cjibrg: `瘋狂小丑`,
	str_3_rqaonzn7kjjiy: `四大發明`,
	str_3_m94wkgy3daxta: `神秘之沙`,
	str_3_tocki7xk7xwq1: `火焰珍珠賓果`,
	str_3_cz3wgrounyetc: `海王賓果`,
	str_3_z7k6mqf3z495a: `加密躁狂者賓果`,
	str_3_fqho1inijjfwo: `東海龍王`,
	str_3_8kzbot4rew7ds: `西遊記`,
	str_3_gsttgo1debywc: `八角形寶石 2`,
	str_3_quofrdenycyyn: `八卦2`,
	str_3_1wt58azdhdo6c: `仙女百搭`,
	str_3_n1ydr5mncpogn: `辣椒獵人`,
	str_3_gn1bc1kqj7gr4: `八卦`,
	str_3_dxxsh3dfmjpio: `太上老君`,
	str_3_9ii7s6u5xbhzh: `世界之樹`,
	str_3_wcaadzg74mj7y: `鷹夫人`,
	str_3_s77hiogba5dhe: `蟠桃會`,
	str_3_bzgza4umpbwsh: `三太子傳奇`,
	str_3_bmr8675wqiigs: `可愛女巫`,
	str_3_oajk3h9o685xq: `庫`,
	str_3_ur8593z8hu17w: `火燒珍珠`,
	str_3_j9nzkkbjfaz1a: `荷魯斯之眼`,
	str_3_1ru5x5zx7us6r: `閃電神`,
	str_3_5ii9zgw5unc3h: `海王寶藏`,
	str_3_wykepsq659qp4: `四龍`,
	str_3_q9gi4yybyadoe: `百搭大熊貓`,
	str_3_dkzdo35rcipfs: `中國`,
	str_3_ie9eti6w4zfcs: `古代神器`,
	str_3_7cz37fritkfao: `幸運雞`,
	str_3_84igeq3a8r9d6: `金塊獵人`,
	str_3_4tyxfmpnwqokn: `八角形寶石`,
	str_3_soojfuqnaxycn: `水果之夏`,
	str_3_rsjogw1ukbeic: `亞洲四虎`,
	str_3_3yfmucpss64mk: `龍之火焰`,
	str_3_o7f9ih8t6559e: `武則天`,
	str_3_wtupmzq14xepn: `舞獅共舞`,
	str_3_d8cso3u8ct1iw: `鳳凰轉世888`,
	str_3_7tccifcktqre1: `大富豪`,
	str_3_4akkze7ywgukq: `加密躁狂者`,
	str_3_86burqb38a9ua: `武士道`,
	str_3_8u9r4tj48chd1: `炸彈王`,
	str_3_zygj7oqga9nck: `大財神`,
	str_3_srd3xusx3ughr: `進入KTV`,
	str_3_5ypkuepgw61kk: `五行水 送福`,
	str_3_yxdzc9d7qj3zy: `五行火 送福`,
	str_3_g8awyu1xjtgwr: `紅火暴擊`,
	str_3_e4ndsc3ogr5dq: `焰龍 88`,
	str_3_m1xn4je4dccb1: `古代寶石`,
	str_3_qn3ynneqbhgy4: `三虎稱霸`,
	str_3_kqm1cmbpret1y: `小丑珠寶`,
	str_3_knjnnkjqfhsn4: `888 龍傳說`,
	str_3_d5qfgs4amfxf6: `瘋狂旋轉`,
	str_3_ahf5icfts455e: `金福幸運`,
	str_3_c41bsraonrmbq: `玄圃聯歡`,
	str_3_99bzr6d3x39za: `你屬什麼`,
	str_3_x46x869a989x6: `發財財神`,
	str_3_kk8nqm3cfwtng: `海霸`,
	str_3_xkhy6baryz7xs: `海王 2 Ex _ 新手`,
	str_3_qq5ocdypyeboy: `海王 2 Ex _ 初手`,
	str_3_g54rso4yefdrq: `海王 2 Ex _ 專手`,
	str_3_ary5bxi9z165r: `海王 2 Ex _ 好友吧`,
	str_3_b8rzo7uzqt4sw: `金蟾埔魚`,
	str_3_8d7r1okge7nrk: `大聖鬧海`,
	str_3_nzkseaudcbosc: `李逵劈魚`,
	str_3_wi17jwsu4de7c: `搖錢樹`,
	str_3_1jeqx59c7ztqg: `海王3`,
	str_3_4omkmmpnwqokn: `海綿寶寶`,
	str_3_st5cmuqnaxycn: `開心捕魚5`,
	str_3_ddpg1amgc71gk: `蟲蟲樂園`,
	str_3_p63ornyjba8oa: `漁人碼頭`,
	str_3_xq9ohbyf9m79o: `鳥王爭霸飛鼠御天`,
	str_3_hcu3p8r71kj3y: `超級巨星`,
	str_3_hf5hx8w9u1q3r: `聖約之書 豪華版`,
	str_3_43bx3e7ywgukq: `海豚的珍珠 豪華版`,
	str_3_ateqfxp1sqamn: `海豚寶藏`,
	str_3_fk9yoi4wkifrs: `50金獅`,
	str_3_ww3a8wsu4de7c: `夏日水果`,
	str_3_8nsbhokge7nrk: `尼羅河女王`,
	str_3_qxoindypyeboy: `藝妓`,
	str_3_xmzfobaryz7xs: `海洋之王`,
	str_3_7f9h9fwz11kaw: `幸運女神護身符豪華版`,
	str_3_ioheiiqk3xrc1: `聖約之書`,
	str_3_k9gz4ebbrau1e: `黃金雙龍`,
	str_3_aij68ciusna5c: `哥倫布`,
	str_3_satj3o6ya8dcq: `至尊珠寶`,
	str_3_5m6k9j7rwspjs: `羅馬競技場`,
	str_3_igg7tisz4ukhw: `埃及豔后`,
	str_3_w4ypzw6o48mpq: `龍鳳呈祥`,
	str_3_xbxy1yegyhnyk: `森林島冒險記`,
	str_3_foff4ikkjprr1: `水滸傳`,
	str_3_ef1uyxt98o6ur: `財神連線`,
	str_3_naagsa5ycfugq: `古埃及`,
	str_3_i4rc816e388c6: `羅賓漢`,
	str_3_nh9swadbc3use: `高速之冠連線`,
	str_3_tqi9778i7mi6o: `邁阿密`,
	str_3_byz81hmsq748k: `至尊財神`,
	str_3_ruufkzk1kpefn: `銀子彈連線`,
	str_3_awn5jciusna5c: `藏寶 船長連線`,
	str_3_3hj4fkfji4z4a: `財神 發發發 2`,
	str_3_u17q53q45xcp1: `白蛇傳`,
	str_3_kia1eetdryo1c: `愛麗思`,
	str_3_9xpa7brfxj7zo: `媽媽咪呀`,
	str_3_pirtanombyroh: `野蠻世界`,
	str_3_ne4gq55cpitgg: `魔豆`,
	str_3_k3anse3yrrunq: `西部警長`,
	str_3_79mafnrjt48aa: `潘金蓮`,
	str_3_fwria11mjbrwh: `三國爭霸`,
	str_3_dc7sh3dfmjpio: `龍虎`,
	str_3_3uim5ppkiqwk1: `魚蝦蟹`,
	str_3_j3wngk3efrzn6: `百家樂`,
	str_3_yr1zy9u9xt6zr: `葫蘆`,
	str_3_hxb3p8r71kj3y: `骰寶`,
	str_3_8rqwot18etnuw: `雷神`,
	str_3_9upe5bm4xph81: `齊天大聖`,
	str_3_113qm5xnhxoqn: `阿拉丁神燈`,
	str_3_ywozehuuqbazc: `黃金島`,
	str_3_bcizh7dipjiso: `花木蘭`,
	str_3_55hj8ghaugxj6: `笑彌勒`,
	str_3_jpiuhpbifei1o: `金雞報喜`,
	str_3_itzp5iqk3xrc1: `百搭的 精神`,
	str_3_7rw3tfwz11kaw: `北極寶藏`,
	str_3_aodmmxp1sqamn: `招財進寶`,
	str_3_o3nxzh9o685xq: `飛龍在天`,
	str_3_ufc6t3z8hu17w: `聖誕驚喜`,
	str_3_j6j1rkbjfaz1a: `五虎將`,
	str_3_9w6aa6u5xbhzh: `金龍發發`,
	str_3_wpu7pzg74mj7y: `吉鼓發財`,
	str_3_tbfxuhxs694xk: `財富熊貓`,
	str_3_gd3rn1kqj7gr4: `女王`,
	str_3_wfo7bzs95uq7r: `弓箭手`,
	str_3_jsguaktmfyw1h: `大力神`,
	str_3_dhdirsn3m3xia: `財神到`,
	str_3_kf41ymtxfos1r: `海洋天堂`,
	str_3_ebudnqj68h6d4: `歡樂節慶`,
	str_3_9mqe9bhroi78s: `金猴王`,
	str_3_4d5kdkpqi6sk4: `熱血探險記`,
	str_3_5864tji8w113w: `泰國風情`,
	str_3_1q36p58phmt6y: `阿拉丁`,
	str_3_xtpy4bx49xhx1: `探險非洲`,
	str_3_69xaiyrbo4dae: `狂歡夜`,
	str_3_z1pc5tp4zqhm1: `銀子彈`,
	str_3_bes8675wqiigs: `寶藏船長`,
	str_3_bwwza4umpbwsh: `熊之舞`,
	str_3_qieoeyodyyyoc: `藏寶船長加強版`,
	str_3_rh8iwwntk3mie: `海豚世界`,
	str_3_axt5pxf7sk35y: `高速之冠`,
	str_3_jbzd1cjsgh4dk: `斯巴達`,
	str_3_oqt9p9876m39y: `阿茲特克金字塔`,
	str_3_t656f48j75z6a: `偉大藍海`,
	str_3_s6xhiogba5dhe: `足球`,
	str_11_102614: `發發發2`,
	str_11_102617: `吉吉吉`,
	str_11_102618: `性感女神`,
	str_11_102619: `白獅王`,
	str_11_102623: `美猴王`,
	str_11_102612: `撲克派對`,
	str_11_102620: `高速之王`,
	str_11_10211: `土豪船長`,
	str_11_10212: `幽靈海`,
	str_11_10213: `毒梟大亂鬥`,
	str_11_802101: `海洋之心`,
	str_11_102621: `船長寶藏`,
	str_11_102620: `高速之王`,
	str_11_802601: `爆獎777`,
	str_11_102612: `撲克派對`,
	str_11_20264: `女僕`,
	str_11_802604: `殺殭屍`,
	str_11_802606: `歐洲盃2021`,
	str_11_202613: `大香蕉`,
	str_11_202611: `妖狐`,
	str_11_102615: `南國女帝`,
	str_11_102616: `埃及傳奇`,
	str_11_10264: `雷電封神`,
	str_11_702619: `瘋狂樂園`,
	str_13_7_7001: `龍王捕魚`,
	str_13_7_7002: `龍王捕魚2`,
	str_13_7_7003: `財神捕魚`,
	str_13_7_7004: `五龍捕魚`,
	str_13_7_7005: `捕魚一路發`,
	str_13_7_7006: `獵龍高手`,
	str_13_7_7007: `捕魚迪斯可`,
	str_13_0_8001: `幸運龍`,
	str_13_0_8002: `唐伯虎點秋香`,
	str_13_0_8003: `變臉`,
	str_13_0_8004: `悟空`,
	str_13_0_8005: `駱馬大冒險`,
	str_13_0_8006: `臺灣黑熊`,
	str_13_0_8007: `幸運麟`,
	str_13_0_8014: `招財獅`,
	str_13_0_8015: `月光秘寶`,
	str_13_0_8016: `上班族狂想曲`,
	str_13_0_8017: `過新年`,
	str_13_0_8018: `拿破侖`,
	str_13_0_8019: `文房四寶`,
	str_13_0_8020: `芝麻開門`,
	str_13_0_8021: `黃金香蕉帝國`,
	str_13_0_8022: `麻雀無雙`,
	str_13_0_8023: `奧林匹亞神廟`,
	str_13_0_8024: `水晶王國`,
	str_13_0_8025: `神偷妙賊`,
	str_13_0_8026: `熱舞教父`,
	str_13_0_8027: `料理廚王`,
	str_13_0_8028: `幸運淘金鼠`,
	str_13_0_8029: `奇幻糖果島`,
	str_13_0_8030: `瘋狂科學家`,
	str_13_0_8031: `金餃子`,
	str_13_0_8034: `金錢俠`,
	str_13_0_8035: `幸運鳳`,
	str_13_0_8036: `龍王`,
	str_13_0_8037: `魔術秀`,
	str_13_0_8044: `江山美人`,
	str_13_0_8046: `關公`,
	str_13_0_8047: `變臉2`,
	str_13_0_8048: `芝麻開門2`,
	str_13_0_8049: `唐伯虎點秋香2`,
	str_13_0_8050: `馬上有錢`,
	str_13_0_15001: `金雞報囍`,
	str_13_0_15002: `齊天大聖`,
	str_13_0_15004: `火牛陣`,
	str_13_0_15005: `幸運福娃`,
	str_13_0_15006: `印加帝國`,
	str_13_0_15009: `忍者大進擊`,
	str_13_0_15010: `熊貓廚王`,
	str_13_0_15011: `後羿傳`,
	str_13_0_15012: `五福臨門`,
	str_13_0_15013: `九尾狐`,
	str_13_0_14001: `鬥雞`,
	str_13_0_14002: `瑪雅大冒險`,
	str_13_0_14003: `屌絲熊貓`,
	str_13_0_14004: `塞爾達傳說`,
	str_13_0_14005: `包大人`,
	str_13_0_14006: `億萬富翁`,
	str_13_0_14007: `一拳超人`,
	str_13_0_14008: `神龍大俠`,
	str_13_0_14010: `飛龍在天`,
	str_13_0_14011: `銀河護衛隊`,
	str_13_0_14012: `街頭霸王`,
	str_13_0_14013: `街頭霸王`,
	str_13_0_14015: `星球大戰`,
	str_13_0_14016: `王牌特工`,
	str_13_0_14017: `少女前線`,
	str_13_0_14018: `妲己`,
	str_13_0_14019: `寶石物語`,
	str_13_0_14020: `魔法乳神`,
	str_13_0_14021: `錢滾錢`,
	str_13_0_14022: `採礦土豪`,
	str_13_0_14023: `賭王撲克`,
	str_13_0_14025: `幸運賽車`,
	str_13_0_14026: `發大財`,
	str_13_0_14027: `好運777`,
	str_13_0_14029: `東方神獸`,
	str_13_0_14030: `三倍金剛`,
	str_13_0_14033: `飛鳥派對`,
	str_13_0_14034: `狗來富`,
	str_13_0_14035: `龍舞`,
	str_13_0_14036: `超級牛B`,
	str_13_0_14038: `埃及奪寶`,
	str_13_0_14039: `開運奪寶`,
	str_13_0_14040: `七海奪寶`,
	str_13_0_14041: `雷神之錘`,
	str_13_0_14042: `聚寶盆`,
	str_13_0_14043: `蹦迪吧`,
	str_13_0_14044: `古怪金剛`,
	str_13_0_14045: `超級牛B 豪華版`,
	str_13_0_14046: `採礦寶貝`,
	str_13_0_14047: `富豪哥`,
	str_13_0_14048: `龍虎百搭`,
	str_13_0_14049: `水果爆爆樂`,
	str_13_0_14050: `浪花`,
	str_13_0_14051: `鯉躍龍門`,
	str_13_0_14052: `叢林活寶`,
	str_13_0_14053: `浪花2`,
	str_13_0_14054: `超級鑽`,
	str_13_0_14055: `金剛`,
	str_13_0_14056: `暴龍兄弟`,
	str_13_0_14057: `忍者X`,
	str_13_0_14058: `飛象財富`,
	str_13_0_14059: `超能IV`,
	str_13_0_14060: `財富燈籠`,
	str_13_0_14061: `瑪雅金瘋狂`,
	str_13_0_14062: `帝國戰爭`,
	str_13_0_14063: `大三元`,
	str_13_0_14064: `爆爆派對`,
	str_13_0_14065: `花開富貴`,
	str_13_0_14066: `星航`,
	str_13_0_14067: `白富美`,
	str_4_ermj: `二人麻將`,
	str_4_blackjack: `21點`,
	str_4_sangong: `三公`,
	str_4_qydz: `全押德州`,
	str_4_zjh: `炸金花`,
	str_4_blnn: `牛牛`,
	str_4_baccarat: `百家樂`,
	str_4_tbnn: `通比牛牛`,
	str_4_hbmj: `卡五星`,
	str_4_dzmj: `大眾麻將`,
	str_4_gdmj: `廣東麻將`,
	str_4_hnmj: `湖南麻將`,
	str_4_rbwar: `紅黑大戰`,
	str_4_hzmj: `杭州麻將`,
	str_4_mjxzdd: `血戰到底`,
	str_4_mjxlch: `血流成河`,
	str_4_gyzjmj: `貴陽捉雞`,
	str_14_1001: `海霸王`,
	str_14_1002: `吃我一炮`,
	str_14_1003: `三仙捕魚`,
	str_14_1004: `獵龍霸主`,
	str_14_1006: `一槌爆富`,
	str_14_1007: `植物大戰恐龍`,
	str_14_1009: `三仙劈魚`,
	str_14_2001: `金牌龍虎`,
	str_14_2002: `百人牛牛`,
	str_14_2003: `喜錢炸金花`,
	str_14_2004: `二八槓`,
	str_14_2006: `百家樂`,
	str_14_2005: `三公`,
	str_14_2007: `十三水`,
	str_14_2008: `二十一點`,
	str_14_2009: `德州撲克`,
	str_14_2010: `搶紅包`,
	str_14_2011: `搶莊牛牛`,
	str_14_3001: `鑽石大亨`,
	str_14_3002: `魚躍龍門`,
	str_14_3003: `發起來`,
	str_14_3004: `獅霸天下`,
	str_14_3005: `大秘寶`,
	str_14_3006: `埃及神諭`,
	str_14_3007: `財神到`,
	str_14_3008: `大糖盛世`,
	str_14_3009: `發財獅`,
	str_14_3010: `大聖猴哥`,
	str_14_3011: `搶金庫`,
	str_14_3012: `五聖獸`,
	str_14_3013: `嗨起來`,
	str_14_3014: `阿拉伯`,
	str_14_3015: `餓狼傳說`,
	str_14_3016: `水果晶鑽`,
	str_14_3017: `高爾夫`,
	str_14_3018: `虎霸王`,
	str_14_3019: `宙斯神`,
	str_14_3020: `德古拉`,
	str_14_3021: `海盜王`,
	str_14_3022: `愛麗絲`,
	str_14_3023: `石器原始人`,
	str_14_3024: `雷霸龍`,
	str_14_3025: `馬戲之王`,
	str_14_3026: `點石成金`,
	str_14_3027: `馬雅王`,
	str_14_3028: `水果Bar`,
	str_14_3029: `發財龍`,
	str_14_3030: `金猴爺`,
	str_14_3031: `福神到`,
	str_14_3032: `熊貓俠`,
	str_14_3033: `馬上發`,
	str_14_3034: `777`,
	str_14_3035: `三倍猴哥`,
	str_14_3036: `趙雲無雙`,
	str_14_3037: `火鳳凰`,
	str_14_3038: `呂姬無雙`,
	str_14_3039: `寶你發`,
	str_14_3040: `很多妹子`,
	str_14_3041: `更多妹子`,
	str_14_3042: `旺財神`,
	str_14_3043: `給貓金幣`,
	str_14_3044: `天外飛仙`,
	str_14_3045: `送錢鼠`,
	str_14_3046: `小廚娘`,
	str_14_3047: `寶礦利`,
	str_14_3048: `冰果霸`,
	str_14_3049: `黃金眼`,
	str_14_3050: `轟炸雞`,
	str_14_3051: `蔬香人家`,
	str_14_3052: `羅馬帝國`,
	str_14_3054: `拳力制霸`,
	str_14_3055: `埃及王朝`,
	str_14_3056: `魔龍秘寶`,
	str_14_3057: `你會胡`,
	str_14_3058: `發紅包`,
	str_14_3059: `犇牛寶`,
	str_14_4001: `梯子遊戲`,
	str_14_4002: `射龍門`,
	str_14_4003: `淘金蛋`,
	str_14_4009: `衝裝啦`,
	str_15_2: `二人麻將`,
	str_15_3: `搶莊牛牛`,
	str_15_4: `百人牛牛`,
	str_15_5: `龍王捕魚`,
	str_15_6: `多財多福`,
	str_15_7: `競咪楚漢德州`,
	str_15_8: `推筒子`,
	str_15_9: `加倍鬥地主`,
	str_15_10: `保險楚漢德州`,
	str_15_11: `血戰到底`,
	str_15_12: `炸金花`,
	str_15_13: `必下德州`,
	str_15_14: `百人三公`,
	str_15_15: `十三水`,
	str_15_17: `3D捕魚`,
	str_15_19: `開心搖搖樂`,
	str_15_20: `通比牛牛`,
	str_15_22: `百家樂`,
	str_15_23: `二八槓`,
	str_15_24: `廣東推倒胡`,
	str_15_25: `二十一點`,
	str_15_26: `廣東雞平胡`,
	str_15_33: `經典搶莊牛牛`,
	str_15_35: `森林舞會`,
	str_15_39: `跑得快`,
	str_15_42: `血流成河`,
	str_15_44: `龍虎鬥`,
	str_15_45: `牛牛大吃小`,
	str_15_47: `開心翻翻樂`,
	str_15_49: `新版鬥地主`,
	str_15_51: `魚蝦蟹`,
	str_15_52: `看四張搶莊牛牛`,
	str_15_53: `三公大吃小`,
	str_15_55: `臺灣麻將`,
	str_15_56: `水果杯`,
	str_16_baccarat: `百家樂`,
	str_16_dragontiger: `龍虎`,
	str_16_topcard: `足球廳`,
	str_16_blackjack: `二十一點`,
	str_16_scalableblackjack: `無限制二十一點`,
	str_16_roulette: `輪盤`,
	str_16_americanroulette: `美式輪盤`,
	str_16_instantroulette: `輪盤時時開`,
	str_16_craps: `花旗骰`,
	str_16_moneywheel: `財富轉盤/追夢轉盤`,
	str_16_sicbo: `超級骰寶`,
	str_1_300: '東海龍王',
	str_1_301: '龍虎爭霸',
	str_1_302: '雷霆宙斯',


	str_100: `福神報喜`,
	str_101: `發發發2`,
	str_102: `決戰三國`,
	str_103: `德古拉夫人`,
	str_104: `埃及寶藏`,
	str_300: '東海龍王',
	str_301: '龍虎爭霸',
	str_302: '雷霆宙斯',
	str_303: `撒哈拉之夜`,
	str_304: `澤達的財富`,

	str_1000: '飛龍捕魚',
	str_1001: '星空捕魚',
	str_1002: '經典捕魚',
	str_1003: '復古捕魚',
	str_1004: '街機捕魚',
  str_1005: '創世捕魚',


	str_10_30300101: '神龙宝藏',
	str_10_30300501: '悟空打鱼',
	str_10_30300201: '摇钱树',
	str_10_30300301: '金蟾捕鱼',
	str_10_30300401: '李逵劈鱼',
	str_10_30300601: '大圣闹海',
	str_10_30300701: '三色鳄鱼',
	str_101_100: 'GB捕鱼',
	str_gamesneme_0: `熱門`,
	str_gamesneme_1: `通用`,
	str_gamesneme_2: `遊戲`,
	str_gamesneme_3: `電子`,
	str_gamesneme_4: `本地`,
	str_gamesneme_5: `捕魚`,
	str_gamesneme_6: `棋牌`,
	str_gamesneme_7: `電競`,
	str_gamesneme_all: `全部`,

	str_ChannelsName_1: `GB彩票`,
	str_ChannelsName_2: `WM`,
	str_ChannelsName_3: `JOKER`,
	str_ChannelsName_4: `博樂`,
	str_ChannelsName_5: `SBO`,
	str_ChannelsName_6: `CQ9`,
	str_ChannelsName_7: `開元`,
	str_ChannelsName_8: `BBIN`,
	str_ChannelsName_9: `SEXY`,
	str_ChannelsName_10: `DG`,
	str_ChannelsName_11: `FUNKY`,
	str_ChannelsName_12: `樂遊`,
	str_ChannelsName_13: `JDB`,
	str_ChannelsName_14: `DS`,
	str_ChannelsName_15: `VG`,
	str_ChannelsName_16: `EVO`,
	str_ChannelsName_100: `GB捕魚`,
	str_ChannelsName_101: `GB`,
	str_balanceType_5: `VIP升級彩金`,
	str_balanceType_2: `每日首充`,
	str_balanceType_6: `彩金`,
	str_balanceType_7: `提款`,
	str_balanceType_8: `充值`,
	str_balanceType_9: `額度轉換`,
	str_balanceType_10: `洗碼返利`,
	str_balanceType_11: `人工上分`,
	str_balanceType_12: `充值贈金`,
	str_balanceType_13: `提現退回`,
	str_balanceType_14: `紅包活動`,
	str_balanceType_15: `轉盤抽獎`,
	str_balanceType_16: `闖關活動`,
	str_balanceType_17: `首充百分百`,
	str_balanceType_18: `傭金轉入`,
	str_balanceType_19: '優惠紅利',
	str_balanceType_20: '異動金額',
	str_info_title: `個人資料`,
	str_info_portrait: `大頭照`,
	str_info_name: `真實姓名`,
	str_info_phonenumber: `手機號碼`,
	str_info_nickname: `暱稱`,
	str_info_bankcard: `銀行帳號`,
	str_info_birthday: `生日`,
	str_info_email: `電子信箱`,
	str_maintain_maintain: `網站維護中`,
	str_maintain_sorry: `抱歉！站臺維護中，由此造成不便，請您諒解！`,
	str_activity_title: `活動`,
	str_activity_tab1: `全部`,
	str_activity_tab2: `最新`,
	str_activity_tab3: `新人`,
	str_activity_tab4: `貴賓 `,
	str_activity_tab5: `日常`,
	str_activitydt_title: `活動詳情`,
	str_login_title: `登入`,
	str_login_resSuccess: `登入成功`,
	str_login_registernew: `先去逛逛`,
	str_login_registernew2: `註冊新使用者`,
	str_login_forget: `忘記登入密碼`,
	str_login_Login: `登入`,
	str_register_title: `註冊`,
	str_register_form_phonePl: `請輸入手機號碼`,
	str_register_form_passwords: `請設定6_20位登入密碼`,
	str_register_Download: `立即下載APP（推薦）`,
	str_register_Enter: `進入線上遊戲`,
	str_register_message_phone: `請輸入手機號碼`,
	str_register_message_code: `請輸入手機驗證碼`,
	str_register_message_password: `請輸入密碼`,
	str_register_message_pwdlen: `密碼長度必須大於等於6個字元小於20個字元`,
	str_register_message_pwdCon: `兩次密碼輸入不一致`,
	str_register_message_pwd: `請輸入重復密碼`,
	str_register_message_agress: `請勾選同意使用者服務協議`,
	str_register_Tick: `勾選同意`,
	str_register_agreement: `使用者服務協議`,
	str_register_registernow: `立即註冊`,
	str_register_existing: `已有帳號，立即登入`,
	str_register_resSuccess: `註冊成功`,
	str_register_getCode: `獲取驗證碼`,
	str_password_title: `重置密碼`,
	str_password_oldpassword: `請輸入原始密碼`,
	str_password_newpassword: `請輸入新密碼`,
	str_password_password: `請再次輸入新密碼`,
	str_password_phone: `請輸入手機號碼`,
	str_password_code: `請輸入手機驗證碼`,
	str_password_getCode: `獲取驗證碼`,
	str_password_succeeded: `密碼重設成功`,
	str_password_Jump: `跳轉登入頁`,
	str_password_Enter: `進入登入頁`,
	str_password_Verify: `驗證手機`,
	str_password_rebuild: `重置密碼`,
	str_password_complete: `完成`,
	str_safety_title: `設定支付密碼`,
	str_safety_pwd: `修改登入密碼`,
	str_safety_payPwd: `設定取款密碼`,
	str_pwd_title: `修改登入密碼`,
	str_service_title: `客服`,
	str_service_contentOpen: `千萬獎池一觸即發`,
	str_service_contentzhuan: `賺錢娛樂兩不誤`,
	str_service_contentzhuce: `提現諮詢`,
	str_service_contentfuwu: `24小時專線服務專線服務貼心至上`,
	str_my_title: `我的`,
	str_my_box_jiaoyi: `交易記錄`,
	str_my_box_touzhu: `投注記錄`,
	str_my_box_dengji: `積分兌換`,
	str_my_box_tuiguang: `邀請推廣`,
	str_my_balance: `餘額`,
	str_my_fanyong: `今日返傭`,
	str_my_recharge: `充值`,
	str_my_withdrawal: `提現`,
	str_my_personal: `個人資料`,
	str_my_bank: `銀行帳號`,
	str_my_account: `帳號安全`,
	str_my_vip: `VIP`,
	str_my_Download: `APP下載`,
	str_my_news: `我的訊息`,
	str_my_upgrade: `檢測升級`,
	str_my_eliminate: `清除緩存`,
	str_my_out: `登出`,
	str_withdrawal_binding: `請選擇提現方式`,
	str_withdrawal_number: `尾號`,
	str_withdrawal_bankcard: `儲蓄卡`,
	str_withdrawal_Disable: `使用者已禁用`,
	str_withdrawal_balance: `餘額`,
	str_withdrawal_quota: `可提現額度`,
	str_withdrawal_money: `提現金額`,
	str_withdrawal_minimum: `最低取款金額`,
	str_withdrawal_withdraw: `請輸入6位取款密碼`,
	str_withdrawal_regulations: `提現金額最低`,
	str_withdrawal_Withdrawals: `提現`,
	str_withdrawal_Please_enter: `請輸入提現金額`,
	str_withdrawal_Insufficient: `可提現餘額不足`,
	str_withdrawal_greater_than: `提現金額必須大於`,
	str_withdrawal_password: `請輸入提現密碼`,
	str_withdrawal_success: `申請提現成功`,
	str_withdrawal_set_up: `請設定支付密碼後再取款`,
	str_withdrawal_choice: `請選擇銀行卡`,
	str_integral_title: `積分兌換`,
	str_integral_IntegralIncrease: `積分增加`,
	str_integral_PointExchange: `積分兌換`,
	str_integral_available: `可用積分`,
	str_integral_time: `時間`,
	str_integral_lable: `積分`,
	str_spread_title: `邀請推廣`,
	str_spread_can: `可選取金額`,
	str_spread_amount: `轉入金額`,
	str_spread_Cumulative: `累計傭金`,
	str_spread_team: `團隊總人數`,
	str_spread_commission: `今日傭金`,
	str_spread_extension: `今日推廣人數`,
	str_spread_Promotion: `推廣渠道一`,
	str_spread_Promotion2: `推廣渠道二`,
	str_spread_Promotion_link: `推廣連結`,
	str_spread_copy: `複製連結給好友`,
	str_spread_preservation: `儲存邀請二維碼`,
	str_spread_Commission: `傭金轉餘額`,
	str_spread_notes: `備註：佣金轉入餘額即可提款`,
	str_spread_all: `全部轉入`,
	str_spread_success: `儲存成功`,
	str_spread_fail: `儲存失敗`,
	str_spread_alls_all: `全部`,
	str_spread_alls_level: `層級`,
	str_spread_alls_search: `搜尋`,
	str_spread_alls_account: `帳號`,
	str_spread_alls_generation: `第幾代`,
	str_spread_alls_today: `累計流水`,
	str_spread_alls_team: `團隊人數`,
	str_record_trade: `交易記錄`,
	str_record_betting: `投注記錄`,
	str_record_No_data: `暫無資料`,
	str_record_searchText_0: `今日`,
	str_record_searchText_2: `最近3日`,
	str_record_searchText_6: `最近7日`,
	str_record_searchText_29: ` 最近30日`,
	str_record_topText: `篩選`,
	str_record_betting_title: `投註記錄詳情`,
	str_bettingDetail_pingtai: `平臺名稱`,
	str_bettingDetail_title: `投註詳情`,
	str_bettingDetail_name: `遊戲名稱`,
	str_bettingDetail_channel: `遊戲型別`,
	str_bettingDetail_orderStatus: `訂單狀態`,
	str_bettingDetail_gameType: `訂單狀態`,
	str_bettingDetail_dateDesc: `下注時間`,
	str_bettingDetail_accountDesc: `下注總金額`,
	str_bettingDetail_lotteryAccount: `中獎金額`,
	str_bettingDetail_orderNo: `注單號碼`,
	str_bettingDetail_state0: `已結算`,
	str_bettingDetail_state1: `下注中`,
	str_bettingDetail_state2: `無效注單`,
	str_card_title: `銀行卡`,
	str_card_bankName: `銀行`,
	str_card_bankNamePl: `請選擇銀行卡`,
	str_card_bankNo: `帳號`,
	str_card_zskNo: `MoMo`,
	str_card_zskNo1: `請輸入MoMo帳號`,
	str_card_bankNoPl: `請輸入銀行卡帳號`,
	str_card_name: `姓名`,
	str_card_namePl: `請輸入英文姓名`,
	str_card_tips: `請與真實姓名保持一致，否則會影響取款一旦資料送出，只能透過客服修改。`,
	str_card_default: `銀行卡`,
	str_card_choice: `請選擇銀行`,
	str_card_Enterbankcard: `請輸入銀行名稱進行搜尋`,
	str_card_search: `搜尋`,
	str_card_binding: `繫結`,
	str_record_trading_title: `交易詳情`,
	str_record_trading_type: `型別`,
	str_record_trading_orderNo: `單號`,
	str_record_trading_dateTime: `時間`,
	str_record_trading_desc: `審核備註`,
	str_record_trading_progress: `目前進度`,
	str_record_trading_copysuccess: `複製成功`,
	str_record_trading_Recharge: `充值成功`,
	str_code_500: `系統繁忙`,
	str_code_4000: `未登入`,
	str_code_4001: `引數錯誤`,
	str_code_4002: `驗證碼錯誤`,
	str_code_4003: `帳號或密碼錯誤`,
	str_code_4004: `沒有此方法`,
	str_code_4005: `使用者不存在`,
	str_code_4006: `未驗證手機號碼`,
	str_code_4007: `該手機號碼已經被註冊`,
	str_code_4008: `不支援此銀行卡`,
	str_code_4009: `使用者已繫結過銀行卡`,
	str_code_4010: `遊戲登入失敗`,
	str_code_4011: `已經繫結過生日`,
	str_code_4012: `已經繫結過真實姓名`,
	str_code_4013: `未繫結銀行卡`,
	str_code_4014: `選擇的銀行卡與繫結銀行卡不一致`,
	str_code_4015: `帳號已經被禁用`,
	str_code_4016: `優惠領取失敗`,
	str_code_4017: `原密碼輸入錯誤`,
	str_code_4018: `新舊密碼相同`,
	str_code_4019: `取款密碼錯誤`,
	str_code_4020: `新舊取款密碼相同`,
	str_code_4021: `未繫結取款密碼`,
	str_code_4022: `填寫的真實姓名跟繫結真實姓名不一致`,
	str_code_4023: `活動未開啟`,
	str_code_4024: `優惠領取失敗`,
	str_code_4025: `沒有此活動`,
	str_code_4026: `活動尚未開啟兌換`,
	str_code_4027: `已領取過此優惠`,
	str_code_4028: `您已有帳號領取過優惠`,
	str_code_4029: `未達充值條件`,
	str_code_4030: `沒有可領取的優惠`,
	str_code_4031: `積分不足`,
	str_code_4032: `任務未完成`,
	str_code_4033: `已領取過優惠`,
	str_code_4034: `優惠已過期`,
	str_code_4035: `還沒到領取時間`,
	str_code_4036: `今天已領取過優惠`,
	str_code_4037: `沒有可以領取的優惠`,
	str_code_4043: `沒有可轉入的優惠`,
	str_code_4044: `未付款的訂單過多，請聯絡客服`,
	str_code_4045: `驗證碼傳送失敗，請聯絡客服`,
	str_code_4046: `您有未完成的提款，請等待處理`,
	str_name_title: `真實姓名`,
	str_name_name: `真實姓名`,
	str_name_namePl: `請輸入真實姓名`,
	str_name_tips: `真實姓名與銀行卡保持一致，否則會影響取款。一旦資料送出，只能透過客服修改。`,
	str_nick_title: `暱稱`,
	str_nick_nick: `暱稱`,
	str_nick_nickPl: `請輸入暱稱`,
	str_email_title: `繫結信箱`,
	str_email_email: `信箱`,
	str_email_emailPl: `請輸入信箱地址`,
	str_facebook_title: `繫結Facebook`,
	str_facebook_facebook: `臉書`,
	str_facebook_facebookPl: `請輸入Facebook帳號`,
	str_line_title: `繫結Line`,
	str_line_line: `Line`,
	str_line_linePl: `請輸入Line帳號`,
	str_birthday_title: `繫結生日`,
	str_birthday_birthday: `生日`,
	str_birthday_birthdayPl: `請選擇出生年月日`,
	str_vipList_title: `領取獎勵`,
	str_vipList_tip: `升級禮金`,
	str_vipList_yuan: `元`,
	str_vipList_yi: `已領取`,
	str_vipList_now: `立即領取`,
	str_viprules_title: `升級規則`,
	str_viprules_tip: `升級禮金`,
	str_viprules_e: `投注額`,
	str_viprules_leiji: `充值`,
	str_vip_title: `等級特權`,
	str_vip_content_current: `當前投注`,
	str_vip_content_difference: `還差`,
	str_vip_content_Bet: `投注即可升級到`,
	str_vip_content_receive: `領取升級彩金`,
	str_vip_content_Betamount: `投注額（元）`,
	str_vip_content_Recharge: `充值（元）`,
	str_vip_content_Promotion: `升級彩金（元）`,
	str_vip_content_vip: `VIP特權`,
	str_vip_content_see: `檢視全部`,
	str_vip_content_Promotiongift: `升級禮金`,
	str_vip_content_More: `更多特權`,
	str_vip_content_wait: `敬請期待`,
	str_vip_content_betRecharge: '當前充值',
	recharge_title: `充值`,
	str_recharge_channel: `通道`,
	str_recharge_choice: `選擇`,
	str_recharge_zfb: `支付寶`,
	str_recharge_payment: `支付方式`,
	str_recharge_money: `充值金額`,
	str_recharge_Please: `請輸入充值金額`,
	str_recharge_amount: `可充值區間`,
	str_recharge_yuan: `元`,
	str_recharge_immediately: `立即充值`,
	str_recharge_order: `訂單編號`,
	str_recharge_order2: '三方訂單號',
	str_recharge_platform: `銀行名稱`,
	str_recharge_username: `使用者姓名`,
	str_recharge_account: `帳戶`,
	str_recharge_copy: `複製`,
	str_recharge_payments: `確認支付`,
	str_recharge_dcWallet: `虛擬幣錢包`,
	str_recharge_Tips: `溫馨提示 ,`,
	str_with_title: `出款`,
	str_balance_title: `餘額詳情`,
	str_balance_total: `總餘額(元)`,
	str_avatar_title: `頭像`,
	str_lucky_title: `幸運優惠`,
	str_lucky_namePl: `請輸入優惠程式碼`,
	str_lucky_tp: `恭喜獲得幸運彩金`,
	str_lucky_info: `請聯系客服領取優惠程式碼`,
	str_lucky_bot: `優惠最高可獲得5866元`,
	str_lucky_tips: `在遊戲中完成一筆存款後，即可獲得彩金`,
	str_lucky_resSuccess: `領取成功`,
	str_rebate_title: `返水`,
	str_rebate_btn: `VIP返水`,
	str_rebate_lingqu: `領取彩金`,
	str_rebate_footTip: `今日可領取彩金`,
	str_rebate_table1: `時間`,
	str_rebate_table2: `分類`,
	str_rebate_table3: `洗碼量`,
	str_rebate_table4: `返水比例`,
	str_rebate_table5: `返水彩金`,
	str_rebate_table6: `狀態`,
	str_vip_rebate_title: `洗碼返利`,
	str_vip_rebate_title2: `活動說明`,
	str_vip_rebate_vip: `VIP等級`,
	str_log_titleW: `提款記錄`,
	str_log_titleR: `充值記錄`,
	str_log_amount: `金額`,
	str_log_Application: `申請時間`,
	str_log_Audit: `審核時間`,
	str_log_state: `狀態`,
	str_log_Tobepaid: `待支付`,
	str_log_success: `成功`,
	str_log_Paid: `已支付`,
	str_log_close: `訂單關閉`,
	str_log_launch: `提交出款`,
	str_log_WithdrawalSucceeded: `出款成功`,
	str_log_WithdrawalFailed: `出款失敗`,
	str_log_remarks: `備註`,
	str_log_nothing: `無`,
	str_log_shenhe: `審核中`,
	str_rush_title: `每日首充`,
	str_phone_title: `修改電話`,
	str_lower_title: `所有下級`,
	str_achievememt_title: `團隊業績`,
	str_achievememt_account: `帳號`,
	str_achievememt_directly: `直屬`,
	str_achievememt_achievement: `業績`,
	str_achievememt_newly: `新增`,
	str_achievememt_team: `團隊`,
	str_achievememt_income: `所得`,
	str_achievememt_commission: `佣金`,
	str_achievememt_detailed: `詳細`,
	str_achievememt_item: `時間範圍`,
	str_achievememt_user: `會員名稱`,
	str_achievememt_date: `日期`,
	str_memberdetails_title: `會員明細`,
	str_team_title: `團隊傭金`,
	str_message_title: `訊息`,
	str_message_system: `系統`,
	str_message_business: `業務訊息`,
	str_message_Loading: `正在載入`,
	str_message_No: `沒有更多了`,
	str_msg_title: `詳情`,
	str_game_list_title: `電子遊戲`,
	str_update_edition: `版本更新提醒`,
	str_update_Updating: `正在更新`,
	str_update_progress: `更新進度`,
	str_update_fail: `更新失敗`,
	str_update_determine: `確定更新`,
	str_index_top: `GB`,
	str_top_content: `真人娛樂，體育投注，電子遊藝盡在一手掌握`,
	str_top_xiazai: `下載`,
	str_Totalbet: `總投注`,
	str_Totalwinorlose: `總輸贏`,
	str_record_platform: `平臺`,
	str_record_platform2: `有效投注`,
	str_winorlose: `輸贏`,
	str_record_zhudan: `注單`,
	str_trade_all: `全部`,
	str_trade_caijin: `彩金`,
	str_trade_tixian: `提現`,
	str_trade_chongzhi: `充值`,
	str_trade_fanyong: `返傭`,
	str_trade_erdu: `額度轉換`,
	str_trade_shoudong: `手動充值`,
	str_trade_cengjin: `充值贈金`,
	str_trade_tuihui: `提現退回`,
	str_spread_suoyou: '所有下級',
	str_spread_tuandui: '團隊業績',
	str_spread_fanyong: '返傭比例',
	str_qukuan: '請輸入登入密碼',
	str_qukuan_mima: '請輸入原取款密碼',
	str_login_forget2: '如忘記登入密碼请',
	str_chongzhi: '重置密碼',
	str_qukuanmima: '如忘記原取款密碼請',
	str_lianxi: '聯絡客服',
	str_wenxin: '溫馨提示',
	str_card_tishi: '會員只能繫結一個銀行卡帳戶和一個MoMo帳戶，並且戶口持有人姓名必須為相同，繫結後如需修改，請與我們24小時線上客服聯絡。',
	// str_record_platform2:'有效投注'
	str_recharge_chongzhi: '充值通道',
	str_recharge_card: '付款卡號',
	str_service_contentchongzhi: `充值諮詢`,
	str_my_zhanghao: `賬號`,
	str_vip_content_betRecharge: '當前充值',
	str_vip_content_Bet2: '充值即可升級到',
	str_vip_leves: '升級需滿足下列任意一個條件',
	str_vip_leves2: '升級需滿足兩個條件',
	str_Real_name: '真實姓名',
	str_Bank_of_deposit: `開戶銀行`,
	str_Bank_card_number: `銀行卡號`,
	str_truemoney_number: ' MoMo賬號',
	str_withdrawal_mode: '請選擇提現方式',
	str_bank_card: '銀行卡',
	str_Tips: '提示',
	str_go_index: `返回首頁`,
	str_tiem_chaxun: '查詢天數不能大於30天',
	str_Platform_name: '平台名稱',
	str_Bet_amount: `下注額`,
	str_Other_games: `其他遊戲`,
	str_Reset: '重置',
	str_less_than: '查詢區間段須小於30天',
	str_What_level: `第幾級`,
	str_fishing: '捕魚',
	str_Electronics: '電子',
	str_Chess_cards: '棋牌',
	str_lottery: `彩票`,
	str_Real_person: `真人`,
	str_Sports: `體育`,
	str_Copy_link: `複製連結發給好友`,
	str_cancel: `取消`,
	str_no_card_binding: '您還沒綁定銀行卡，是否前去綁定？',
	str_no_true_binding: '您還沒綁定MoMo，是否前去綁定？',
	str_first_charge: '今日首充金額：',
	str_received: '今日獲贈獎金：',
	str_Require: '首充金額要求',
	str_give_away: '贈送彩金',
	str_xima_fanli: '洗碼返利',
	str_Not_selected: '未選取日期',
	str_maintain: '該平臺維護中，請更換其他平臺進行遊戲',
	str_operate: '操作成功',
	str_too_fast: '您的操作太快了，請五秒鐘后再試',
	str_Received_yi: '已領取',
	str_up_to_standard: '今日首充未達標',
	str_wan: '萬',
	str_xima_shouming: '活動說明',
	str_xima_1: '1.每日首次充值訂單大於100.00，即可獲贈彩金。',
	str_xima_2: '2.充值彩金越高，獲贈彩金越多，詳見表格。',
	str_xima_3: '3.活動刷新時間，每日零點。',
	str_xima_4: '4.領取記錄可在交易記錄查看。',
	str_qianbao_guanli: '錢包管理',
	str_massge_my: '我的消息',
	str_go_login: '前往登錄',
	str_no_login: '未登錄',
	str_one_chong: '首充',
	str_xima_5: '1.洗码返利每日2点计算上一日投注赢得返利，',
	str_xima_6: '2.返水比例“50”代表每1万有效投注获赠50',
	str_rebate_wei: '未達標',
	str_download_copy: '複製鏈接',
	str_tigong: '為您提供最優質手機客戶端,',
	str_suixing: '移動隨行，讓您輕鬆玩樂',
	str_baocun: '保存二維碼',
	str_balance:'餘額',
	str_colose: '關閉',
	str_index:'首頁',
	str_about:'關於我們',
	str_service:'遊戲產品服務',
	str_service_desc:'感謝使用SWG遊戲產品服務，SWG提供專業的電子遊戲，我們擁有豐富遊戲經驗，五十種以上遊戲API帶給您最佳遊戲體驗！',
	str_multivariate:'多元娛樂',
	str_multivariate_desc:'涵蓋老虎機、捕魚機、小遊戲、電子彩票、等數類電子遊戲開發，其中更尤其擅長老虎機、捕魚機遊戲。',
	str_scroll_tips:'按照提示上滑',
	str_loading:'加載中',

  str_100: `福神报喜`,
	str_101: `发发发2`,
	str_102: `决战三国`,
	str_103: `德古拉夫人`,
	str_104: `埃及宝藏`,
	str_300: '东海龙王',
	str_301: '龙虎争霸',
	str_302: '雷霆宙斯',
	str_303: `撒哈拉之夜`,
	str_304: `泽达的财富`,
	str_305: `五龙争霸`,
	str_1000: '飞龙捕鱼',
	str_1001: '星空捕鱼',
	str_1001_jdb: '海神捕鱼',
	str_1002: '经典捕鱼',
	str_1002_jdb: '神龙宝藏',
	str_1003: '复古捕鱼',
	str_1004: '街机捕鱼',
	str_1005: '创世捕鱼',
	str_1006: '李逵劈鱼',
	str_1007: '摇钱树',
	str_1008: '福神捕鱼',
	str_2000:'彩金德扑',
  str_2001:'黑杰克',
  str_2002:'百家乐',
  str_2004:'豪客百家乐',
  str_2005:'百人德州' ,
	str_3000:'激情火箭',
  str_3001:'财富气球',
  str_3002:'一飞冲天',
  str_3003:'幸运数字',
  str_3004:'钻石大亨',
  str_3005:'财富滑梯',
  str_3006:'大胃王',
  str_3007:'弹弹乐',
  str_3008:'命运之轮',
  str_3009:'幸运转轮',
  str_3010:'大胃王',
  str_3011:'森林舞会',
  str_3012:'飞禽走兽乐园',
  str_3013:'汽車乐园',
  str_3200:'飞行员',
  str_5000:'神圣吸血鬼',
  str_5001:'拳皇',
  str_5002:'麻将胡了',
  str_5003:'超级王牌',
  str_5004:'伽罗宝石',
  str_5005:'黄金之书',
  str_5006:'龙龙龙',
  str_5007:'庆典之月',
  str_5008:'森巴嘉年华',
  str_5009:'疯狂777',
  str_5010:'美食专家',
  str_5011:'赏金猎人 X ',
  str_5012:'雷神X',
  str_5013:'魔兽世界',
  str_5014:'麻将胡了2',
  str_5015:'美杜莎',
  str_5016:'牛仔对决',
  str_5017:'麻将糊了(短板)',
  str_6000:'哈希大小',
  str_6001:'哈希单双',
  str_6002:'哈希牛牛',

  str_hashblock: '区块HASH:',
  str_hashheight: '区块高度:',
  str_hashbettime: '投注时间:',
  str_hashresulttime: '结算时间:',
  str_hashbettype: '下注内容:',
  str_hashresult: '游戏结果:',

  str_hash_big: '大',
  str_hash_small: '小',
  str_hash_single: '单',
  str_hash_double: '双',
  str_hash_bull: '牛',
  str_hash_zhuang:'庄',
  str_hash_xian:'闲',
  str_hash_he:'和',
  str_hash_win:'赢',


  str_gameresult:'游戏结果:',
	str_gameid:'游戏名:',
	str_recordid:'牌局记录ID:',
	str_username:'用户名:',
	str_bet:'下注:',
	str_win:'输赢:',
	str_isfree:'是否免费游戏:',
	str_starttime:'开始时间:',
	str_endtime:'结束时间:',
	str_detail:'牌局详情',
	str_bonus_detail:'特殊游戏',
	str_special:'特殊游戏奖金:',
	str_jackpot:'奖池奖金:',
  str_gamename:'名称',
  str_betd:'投注',
  str_winorfail:'输赢',
	str_betDetail:'下注详情',
	str_parachutehigh:'跳伞高度:',
	str_parachutemoney:'跳伞金额:',
	str_BombHeight:'火箭高度:',
	str_ting:'厅:',
	str_common_poker:'公共牌',
	str_banker_poker:'庄家',
	str_hander_poker:'玩家',
  str_player_poker:'闲家',
	str_ante:'底注',
	str_flop:'翻牌',
	str_turn:'转牌',
	str_river:'河牌',
	str_joker_bet:'下注',
	str_joker_bonus:'彩金',
	str_iswin:'胜利',
	str_isfold:'弃牌',
	str_isheju:'平局',
	str_custom_ting:'大众厅',
	str_vip_ting:'贵宾厅',
	str_tuhao_ting:'富豪厅',
	str_card_type1:'高牌',
	str_card_type2:'一对',
	str_card_type3:'兩对',
	str_card_type4:'三张',
	str_card_type5:'顺子',
	str_card_type6:'同花',
	str_card_type7:'葫芦',
	str_card_type8:'四条',
	str_card_type9:'同花顺',
	str_card_type10:'皇家同花顺',
  str_card_point:'点',
  str_card_bj_blackjack:'黑杰克',
  str_card_bj_5dragon:'五小龙',
  str_card_bj_bust:'爆牌',
  str_card_bj_double:'双倍',

  str_bjl_zhuang:'庄',
  str_bjl_xian:'闲',
  str_bjl_he:'和',
  str_bjl_zhuang_dui:'庄对',
  str_bjl_xian_dui:'闲对',
  str_bjl_win:'赢',
  str_bjl_arbitrary_pair:'任意对子',
  str_bjl_perfect_pair:'完美对子',

  str_bj_xian:'闲',
  str_bj_bx:'保险',

  str_balloon_size:'气球大小',
  str_balloon_result:'结算金额',

  str_jump_height: '跳傘高度',
  str_jump_amount: '跳傘金額',

  str_amount: '投注金额',
  str_bet_zone: '投注区域',
  str_hit_number: '中奖数字',
  str_odds: '倍率',

  str_mylp_type: '游戏模式',
  str_mylp0: '普通',
  str_mylp1: '免费',
  str_mylp2: '超级加倍',

  str_tzje: '投注金额',
  str_tzfx: '投注风险',
  str_tzds: '投注段数',
  str_tzbs: '投注倍数',
  str_jgbs: '结果倍数',
  str_jg: '结果',
  str_zjjg: '中奖结果',
  str_tzfx_dd: '低等',
  str_tzfx_zd: '中等',
  str_tzfx_gd: '高等',
  str_ext: '加注:',
  str_props: '合成:',
  str_props_type_0: '神奇海域',
  str_props_type_1: '深海巨兽',
  str_props_type_2: '金色传说',
  str_props_type_3: '海洋宝藏',
  str_props_type_4: '召唤神龙',
  str_props_level_0: '青铜',
  str_props_level_1: '白银',
  str_props_level_2: '黄金',

  fishbettype_0: '正常击鱼',
  fishbettype_1: '钻头蟹击鱼',
  fishbettype_2: '钻头蟹返分',

  str_extra: '是否额外下注:',
  str_t: '是',
  str_f: '否',
  str_symbol: '特殊拓展符号',
  str_special_Games: '特殊游戏:',
  str_three_yuan: '大三元',
  str_luckiest_man: '大四喜',
  str_lightning_jet: 'Lightning Jet',
  str_none:'无',
  str_respin: "免费重转:",
  str_gong_niu: '公牛',
  str_niu_zai:'牛仔',
  str_common_pokers:'公共',
  str_poker_card_type1:'高牌',
  str_poker_card_type2:'一对',
  str_poker_card_type3:'两对',
  str_poker_card_type4:'三张',
  str_poker_card_type5:'顺子',
  str_poker_card_type6:'同花',
  str_poker_card_type7:'葫芦',
  str_poker_card_type8:'四条',
  str_poker_card_type9:'同花顺',
  str_poker_card_type10:'皇家同花顺',
  str_Gongniu_Win:'公牛胜',
  str_NiuzaiWin:'牛仔胜',
  str_Tie :'平手',
  str_TwoPair:'两对',
  str_Straight:'顺子',
  str_Flush :'同花',
  str_FullHouse:'葫芦',
  str_Four :'金刚',
  str_3200_gameType:'游戏模式',
  str_3200_BetX100:'下注金额',
  str_3200_CashOutX:'跳伞高度',
  str_3200_WinX100:'盈利',
  str_3200_CrashX:'最终高度',
  str_3200_NOAuto:'手动',
  str_3200_Auto:'自动',
  str_3200_currency:'货币类型:',
  str_3200_roundId:'轮次:',
  str_3200_ForceLeave:'强制踢出',
  str_3200_KickOut:'尝试踢出',
  str_3200_ChangePlayerHard:'调整玩家难度',
  str_3200_ChangeGameHard:'调整游戏难度',
  str_3200_ServerState:'调整服务状态',
  str_dialog_title:'提示',
  str_userId_no:'玩家ID不存在',
  str_gameId_no:'游戏ID不存在',
  str_pausePlayerEntry:'暂停玩家进入',
  str_returnToNormal:'恢复正常',
  str_success:'操作完成',

  str_jokey2002_tip_message:'庄(1:0.95)  闲(1:1)  和(1:8) 庄对(1:11) 闲对(1:11)',
  str_jokey2004_tip_message:'庄(1:0.95)  闲(1:1)  和(1:8) 庄对(1:11) 闲对(1:11)  完美对子(1:25)  任意对子(1:5)',
  str_jokey_tip_title:'当开出和局时,庄闲都退回下注金额',
  str_describe_title:'赔率说明:',
  str_3004_describe_message:" x5赔(50x)      x4赔(5x)      3x2赔(4x)      x3赔(3x)      2X2赔(2x)      x2赔(0.1x) ",
  str_3008_describe_message0:"0:(4x)",
  str_3008_describe_message1:"1:(15x)",
  str_3008_describe_message2:"2:(200x)",
  str_3008_describe_message3:"3:(再接再厉)",
  str_3008_describe_message4:"4:(40x)",
  str_3008_describe_message5:"5:(2x)",
  str_3008_describe_message6:"6:(免费x5)",
  str_3008_describe_message7:"7:(再接再厉)",
  str_3008_describe_message8:"8:(80x)",
  str_3008_describe_message9:"9:(1.5x)",
  str_3008_describe_message10:"10:(20x)",
  str_3008_describe_message11:"11:(1.2x)",
  str_3008_describe_message12:"12:(8x)",
  str_3008_describe_message13:"13:(再接再厉)",
  str_3008_describe_message14:"14:(超级加倍)",
  str_3008_describe_message15:"15:(10x)",
  str_zj_odds:"中奖倍数",
  str_zj_win_index:"开奖位置",

  str_2000_win_value_tip:'  总输赢(赔率+彩金赔付) - 总下注(底注+翻牌+转牌+河牌+彩金) = 赔付(底注+翻牌+转牌，河牌) - 彩金(下注) + 彩金赔付 = 输赢',
  str_2000_win_value_tip2:'  - 总下注(底注+翻牌+转牌+河牌) - 彩金(下注) = 输赢',
  str_game_win_value_total:"输赢计算:",
  str_2000_describe_title:'牌型大小: 皇家同花顺>同花顺>铁支>葫芦>同花>顺子>三条>两对>一对>高牌',
  str_2000_describe_content:'赔付说明: 【底注 1:1】 【翻牌 1:1】  【转牌，河牌 1:1】 ',
  str_2000_describe_message:'彩金的赔付表(不计算公共牌): 【A-A(玩家和庄家) 1000:1】  【A-A(仅玩家) 30:1】  【A-K(同色） 25:1】  【A-Q或者A-J(同色) 20:1】  【A-K(不同色) 15:1】  【K-K或Q-Q或J-J 10:1】 【A-Q或A-J(不同色) 5:1】 【10-10到2-2(对子) 3:1】',
  str_jokey2002_tip_title:' 庄(输赢) + 闲(输赢) + 庄对(输赢) + 闲对(输赢) +闲对(输赢) = 输赢',
  str_jokey2004_tip_title:'庄(输赢) + 闲(输赢) + 庄对(输赢) + 闲对(输赢) + 闲对(输赢) + 完美对子(输赢) + 任意对子(输赢) = 输赢',
  str_game_bet:'下注金额',
  str_game_win:'赢',
  str_game_fail:'输',
  tr_game_total_win:'总输赢',
  str_parachute_money:'跳伞中奖金额',
  str_3001_win_value_tip:'  (投注金额 x 气球大小) - 投注金额 = 结算金额 - 投注金额 = 输赢',
  str_3001_win_value_tip2:'  (投注金额 x 投注中獎倍率) - 投注金额 = 结算金额 - 投注金额 = 输赢',
  str_3002_win_value_tip:'  (投注金额 x 跳伞高度) - 投注金额 = 跳伞金额 - 投注金额 = 输赢',
  str_3003_win_value_tip:'  (投注金额 x 中奖倍率) - 投注金额 = 中奖結果金额 - 投注金额 = 输赢',
  str_3004_win_value_tip:'  (投注金额 x 中奖倍率) - 投注金额 = 输赢',
  str_3005_win_value_tip:'  (投注金额 x 投注中奖倍率) - 投注金额 = 中奖結果金额 - 投注金额= 输赢',
  str_3008_win_value_tip:'  (投注金额 x 中奖倍率(开奖位置对应倍数)) - 投注金额 = 中奖結果金额 - 投注金额 = 输赢',
  str_3009_win_value_tip:'  (投注金额 x 结果倍数) - 投注金额 = 中奖結果金额 - 投注金额 = 输赢',
  str_3011_win_value_tip:'  中奖总金额 - 投注总金额 = 输赢',
  str_3007_win_value_tip:'  (投注金额 x 结果倍数) - 投注金额 = 中奖結果金额 - 投注金额 = 输赢',
  str_2005_win_value_tip:'公牛(输赢) + 牛仔胜(输赢) + 平手(输赢) + 两对(输赢) + 顺子(输赢) + 同花(输赢) + 葫芦(输赢) + 金刚(输赢)= 输赢',
  str_jokey2005_tip_message0:'牌型大小: 皇家同花顺>同花顺>金刚>葫芦>同花>顺子>三条>两对>一对>高牌',
  str_jokey2005_tip_message1:'胜负平区: “牛仔”胜利:1赔0.95(和局全退) “公牛“胜利:1赔0.95(和局全退) 平:1赔18',
  str_jokey2005_tip_message2:'任一人手牌区: 两对:1赔1.3  顺子:1赔8  同花:(同花及皇家同花顺)1赔12 葫芦:1赔15 金刚:1赔250',

  str_jokey2001_tip_message0:'牌型大小比较: 黑杰克>五小龙>普通21点>其他点数·如果庄闲牌型或点数相同视为平局﹐退还下注金额·如果庄闲都爆牌﹐则庄家赢',
  str_jokey2001_tip_message1:'特殊牌型: 黑傑克:莊家牌不是黑傑克那麼莊家賠率為1.5 五小龍:莊家牌型小於您的五小龍﹐莊家賠率為1.5',
  str_jokey2001_tip_message2:'結算公式:保險失敗所輸遊戲幣=保險金額。保險勝利所贏遊戲幣=2*保險金額。閑家失敗所輸遊戲幣=當前下注數+保險失敗所輸遊戲幣-保險勝利所贏遊戲幣。閑家勝利所贏遊戲幣=當前下注數*牌型倍數–保險失敗所輸遊戲幣+保險勝利所贏遊戲幣-抽水。抽水:贏家所贏金額的5%',
  str_game_win_value:'中奖金额',
  str_game_split:'分牌',
  str_game_win_result:'中奖(是/否)',
}



// WEBPACK FOOTER //
// ./src/VueI18n/language-cn.js